import { Client } from './../../../../models/client';
import { DataTableHelpers } from './../../../../components/system/datatable/datatable-helper';
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import {
  ItemSearchOptionField,
  ItemSearchFilter,
  ItemSearchOption,
  ItemSearchOptionFieldOption
} from 'src/app/components/filter-list/models/filterClasses';
import { WorkflowContextService } from 'src/app/services';
import { InspectionQueueComponent } from 'src/app/components/inspections/inspection-queue/inspection-queue.component';
import { ComponentIds } from 'src/app/models/component-ids';

@Component({
    selector: 'app-inspection-requested-queue',
    templateUrl: './inspection-requested-queue.component.html',
    styles: [],
    standalone: false
})
export class InspectionRequestedQueueComponent implements OnInit {
  @Input() client: Client;
  @Output() updateStatus = new EventEmitter();
  @Output() dataLoaded = new EventEmitter<string>();
  @Output() recordCountSet = new EventEmitter<number>();
  @Output() filtersChanged = new EventEmitter<boolean>();

  @ViewChild('wmInspectionQueue', { static: false })
  wmInspectionQueue: InspectionQueueComponent;
  id = ComponentIds.INSPECTION_REQUESTED_QUEUE;

  public columns = [
    { 
      prop: 'address', 
      name: 'Address' 
    },
    { 
      prop: 'city', 
      name: 'City' 
    },
    { 
      prop: 'inspectionType', 
      name: 'Inspection Type' 
    },
    {
      prop: 'scheduledOn',
      name: 'Scheduled Time',
      pipe: this.dtHelpers.getDatePipe('MM/dd/yyy, h:mm a')
    },
    {
      prop: 'inspectorName',
      name: 'Assigned Inspector'
    },
    { 
      prop: 'requestorName', 
      name: 'Requestor Name' 
    },
    { 
      prop: 'requestorPhoneNumber', 
      name: 'Requestor Phone' 
    },
    {
      prop: 'inspectionStatus',
      name: 'Status'
    }
  ];

  staticFilters: ItemSearchFilter;
  public searchPills: ItemSearchOptionField[] = [];

  constructor(
    private context: WorkflowContextService,
    private dtHelpers: DataTableHelpers
  ) {}

  reload() {
    this.wmInspectionQueue.loadInspections().subscribe(z => {
      this.wmInspectionQueue.inspectionRequests = z;
    });
  }

  private loadFilters() {
    this.staticFilters = new ItemSearchFilter({
      options: [
        new ItemSearchOption({
          field: new ItemSearchOptionField({
            title: 'requestorId',
            options: [
              new ItemSearchOptionFieldOption({
                title: 'requestorId',
                selected: true,
                filterText: '',
                searchText: this.context.user.id,
                strOperator: ''
              })
            ]
          })
        })
      ]
    });
  }

  ngOnInit() {
    if (this.context.user) {
      this.loadFilters();
    } else {
      this.context.user$.subscribe(() => {
        this.loadFilters();
      });
    }
  }

  updateStatusEvent(evt) {
    this.updateStatus.emit(evt);
  }

  emitDataLoaded() {
    this.dataLoaded.emit('InspectionRequestedQueueComponent');
  }

  setRecordCount(count: number) {
    this.recordCountSet.emit(count);
  }

  filtersChange() {
    this.filtersChanged.emit(true);
  }
}
